import { render, staticRenderFns } from "./RoleInspectorPopup.vue?vue&type=template&id=f0459846&scoped=true&"
import script from "./RoleInspectorPopup.vue?vue&type=script&lang=js&"
export * from "./RoleInspectorPopup.vue?vue&type=script&lang=js&"
import style0 from "./RoleInspectorPopup.vue?vue&type=style&index=0&id=f0459846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0459846",
  null
  
)

export default component.exports